<script>
import Select from './select.vue';
export default {
  name: 'SelectDefault',
  extends: Select,
  props: {
    isVerific: {
      type: Boolean,
      default: false
    }
  }
};
</script>
